import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isSameDay } from 'date-fns';

import { GetSessions } from '../../actions/sessions';
import { selectDate } from '../../actions/date_nav';

export class NavItemComponent extends PureComponent {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    css: PropTypes.string,
    device: PropTypes.string.isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    formatter: PropTypes.func.isRequired,
    GetSessionsData: PropTypes.func.isRequired,
    SelectDate: PropTypes.func.isRequired,
  };

  static defaultProps = {
    css: 'date-list__btn',
  };

  onClick = e => {
    const { date, GetSessionsData, SelectDate } = this.props;
    e.preventDefault();
    GetSessionsData(date);
    SelectDate(date);
  };

  render() {
    const { css, date, device, formatter, active } = this.props;
    const buttonCss = classNames([css, { active }]);
    return (
      <button onClick={this.onClick} className={buttonCss} type="button">
        {formatter(date, device)}
      </button>
    );
  }
}

const mapStateToProps = ({ general, dateNav: { date: selectedDate } }, { date }) => ({
  device: general.device,
  active: isSameDay(selectedDate, date),
});

const mapDispatchToProps = dispatch => ({
  GetSessionsData: date => dispatch(GetSessions(date)),
  SelectDate: date => dispatch(selectDate(date)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavItemComponent);
